import { Bookmark, BookmarkBorder, CloudDownload, ZoomIn } from '@mui/icons-material'
import { Button, Grid } from '@mui/material'
import InputField from 'components/atoms/fields/InputField'
import SelectField from 'components/atoms/fields/SelectField'
import { Form, Formik } from 'formik'
import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useDELETE_deleteBookmarkMutation, useGET_bookmarksQuery, useGET_resourcesQuery, usePOST_addBookmarkMutation } from 'redux/api/resourcesApi'
import { useGET_schoolSetupFluenciesSelectQuery } from 'redux/api/setupApi'
import { useGET_subjectsSelectQuery } from 'redux/api/subjectsApi'
import { RootState } from 'redux/store'
import { MAX_PER_PAGE } from 'utils/constants'
import formModel, { initialValues } from 'utils/formModels/resourcesModel'
import { gradeSelectData, gradeSelectDataFull, toHtml, translateGradeLevel } from 'utils/helpers'


interface IProps {
    initialGradeLevel?: any
    qry?: string
}

const PopupResources: FC<IProps> = ({qry = ""}) => {
  const { t } = useTranslation()

  const user = useSelector((state: RootState) => state['user'].user)
  const initialGradeLevel = user?.grade_level ?? null

  const [clickedBookmark, setClickedBookmark] = useState(null)
  const [filters, setFilters] = useState({
    page: 1,
    page_size: MAX_PER_PAGE,
    grade_level: '',
    subject: '',
    search: qry || '',
    fluencies: null
  })

  const { data: fluencies } = useGET_schoolSetupFluenciesSelectQuery({
    page: 1, page_size: 9, is_main: true
  })

  const { grade_level, subject, search } = formModel()

  const [addBookmark, {isLoading: isAddBookmarkLoading, isSuccess: createBookmarkSuccess }] = usePOST_addBookmarkMutation()
  const [deleteBookmark, {isLoading: isDeleteBookmarkLoading, isSuccess: deleteBookmarkSuccess}] = useDELETE_deleteBookmarkMutation()
  const isBookmarkLoading = isAddBookmarkLoading || isDeleteBookmarkLoading

  useEffect(() => {
    if(!isBookmarkLoading)
        setClickedBookmark(null)
  }, [isBookmarkLoading])


  const newFilters = {...filters}
  if(!newFilters['fluencies']){
    delete newFilters['fluencies']; 
  }
  
  const { data: bookmarks } = useGET_bookmarksQuery({page: 1, page_size: MAX_PER_PAGE})
  const { data: resources, refetch } = useGET_resourcesQuery({...newFilters})

  useEffect(() => {
    refetch()
  }, [filters])


  let formValues = {...initialValues};
  if(initialGradeLevel)formValues["grade_level"] = {id: initialGradeLevel.toString(), title: translateGradeLevel(initialGradeLevel)};
  if(qry)formValues["search"] = qry;


  return (

      <div>
        <div className="resources-top">

            <Formik
                enableReinitialize
                initialValues={formValues}
                onSubmit={(values) => { }}
                >
                {({ values, setFieldValue, errors }) => {
                return (
                <Form>
                    <Grid container spacing={4}>
                        <Grid item xs={12} md={2}>
                            <SelectField
                                renderChildren={false}
                                fieldProps={{ ...grade_level }}
                                apiCall={gradeSelectDataFull}
                                onChange={(value: { id: any }) => {
                                    setFilters({...filters, grade_level: value.id ?? '' })
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <SelectField
                            fieldProps={{ ...subject }}
                            apiCall={useGET_subjectsSelectQuery}
                            onChange={(value: { id: any }) => {
                                setFilters({...filters, subject: value.id ?? '' })
                            }}
                            />
                        </Grid>

                        <Grid item xs={10} md={5}>
                            <InputField fieldProps={{ ...search }}/>
                        </Grid>

                        <Grid item xs={2} md={1}>
                            <ZoomIn style={{ cursor: 'pointer', fontSize: '40px'}} 
                                onClick={ () => setFilters({...filters, search: values.search })} />
                        </Grid>
                    </Grid>


                </Form>
                    )
                }}
            </Formik>
        </div>

        <Grid container spacing={4}>
            <Grid item xs={4} md={2}>
                <div style={{ height: '100%', borderRight: '1px solid gray' }}>
                    <div style={{ fontWeight: '500', marginBottom: '20px'}}
                        onClick={() => setFilters({...filters, fluencies: null})  }
                    >{t('goalbank.topics')}</div>
                    {
                        fluencies && fluencies.results?.map(f => <div key={f.id} 
                            className={`goalbank-section ${filters.fluencies==f.id ? 'selected': ''}`}
                            onClick={() => { setFilters({...filters, fluencies: f.id}) }}
                            ><div className="goalbank-section-title">
                                {f.title}
                            </div></div>)
                    }
                    </div>
            </Grid>
            <Grid item xs={8} md={10}>
                

                <Grid container spacing={2}>    
                {
                    resources?.results?.length > 0 ? resources.results.map(r => 
                        <Grid key={r.id} item xs={12} sm={6} xl={4}>
                        <div style={{
                            border: '1px solid #ccc',
                            borderRadius: '10px',
                            marginBottom: '10px',
                            background: '#fff',
                            height: '100%',
                            position: 'relative',
                            paddingBottom: '40px'
                        }}>

                            <div style={{
                                aspectRatio: 1.5,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center center',
                                backgroundColor: '#f5f5f5',
                                backgroundImage: `url('${r.image}')`,
                            }}></div>
                            <div style={{ 
                                fontSize: '26px',
                                lineHeight: '32px',
                                fontWeight: '500',
                                padding: '10px'
                            }}>
                                {r.title}     
                            </div>
                            <div style={{ 
                                padding: '10px'
                            }} dangerouslySetInnerHTML={toHtml(r.description)} />
                            <div style={{ 
                                padding: '10px'
                            }} >
                                {t('common.grade-level')}: {translateGradeLevel(r.grade_level)}

                            </div>
                            <div style={{ 
                                position: 'absolute',
                                bottom: '0px',
                                left: '0px',
                                width: '100%',
                                padding: '10px', 
                                display: 'flex', 
                                alignItems: 'center' }}>

                                {r.attachment && 
                                <Button
                                    variant='contained'
                                    color='blue'
                                    size='small'
                                    onClick={() => window.open(r.attachment, '_blank', 'rel=noopener noreferrer')}
                                    >
                                    <CloudDownload />
                                    <span
                                        style={{ fontSize: '12px', marginLeft: '5px' }}
                                    >{t('dashboard.download')}</span>
                                </Button>}

                                <div style={{ marginLeft: 'auto', height: '30px' }}>

                                    {clickedBookmark === r.id ? 
                                        <Bookmark sx={{ position: 'relative', bottom: '-6px', color: 'gray', fontSize: '30px' }} />
                                    :
                                        (bookmarks?.results?.filter(b => b.resource_id === r.id).length > 0 
                                            ? <Bookmark onClick={() => {
                                                    setClickedBookmark(r.id)
                                                    deleteBookmark(bookmarks?.results?.find(b => b.resource_id === r.id).id)} 
                                                }
                                                sx={{ position: 'relative', bottom: '-6px', cursor: 'pointer', fontSize: '30px' }}/>
                                            : <BookmarkBorder onClick={() => {
                                                    setClickedBookmark(r.id)
                                                    addBookmark({resource_id: r.id})} 
                                                }
                                                sx={{ position: 'relative', bottom: '-6px', cursor: 'pointer', fontSize: '30px' }}/>)
                                    }
                                    
                                </div>
                                

                            </div>
                        </div>
                        </Grid>) : 
                        <Grid item xs={12}>
                            {t('dashboard.no-search-results')}
                        </Grid>
                
                }
                </Grid>

                <div style={{ height: '40px'}} />
            </Grid>
        </Grid>
      </div>
  )
}

export default PopupResources